<template lang="html">
    <div class="notification" v-if="text"
        :class="{
            'notification__show': text,
            'notification--danger': icon == 'error',
            'notification--success': icon == 'success',
            'notification--info': icon == 'info',
            'notification--warning': icon == 'warning'
        }">

        <div class="notification__icon-container"
            :class="{
                'notification__icon-container--danger': icon == 'error',
                'notification__icon-container--success': icon == 'success',
                'notification__icon-container--info': icon == 'info',
                'notification__icon-container--warning': icon == 'warning'
            }">
            <img 
                v-if="icon == 'error'" 
                src="@/assets/images/icons/notification-danger.svg" class="notification__icon"
            />
            <img
                v-if="icon === 'success'" 
                src="@/assets/images/icons/notification-success.svg" class="notification__icon"
            />
            <img 
                v-if="icon == 'warning'"
                src="@/assets/images/icons/notification-warning.svg" class="notification__icon"
            />
            <img 
                v-if="icon == 'info'"
                src="@/assets/images/icons/notification-info.svg" class="notification__icon"
            />
        </div>

        <div class="notification__text-container">

             <div v-if="typeof(text) === 'string'"  class="notification__text">
                {{text}}
            </div>

            <div v-else-if="typeof(text) === 'object'" v-for="(subtext,i) in text" class="notification__text">
                {{subtext}}
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            text: 'notification/title',
            icon: 'notification/icon'
        }),
    },
    created() {
        // window.addEventListener('scroll', function(event) {
        //     console.log(event.scrollTop);
        // });
    }
}
</script>

<style lang="scss" scoped>
    .notification {
        position: fixed;
        display: flex;
        justify-content: space-around;
        width: 100%;
        min-height: 60px;
        z-index: 40;
        background: #FFFFFF;
        
        // Under sm
        min-height: 60px;
        right: 0;
        top: calc(-300px);
    
        @keyframes movein {
            from { top: calc(-300px); }
            to   { top: calc(0px); }
        }
        @keyframes moveout {
            from { top: calc(0px); }
            to   { top: calc(-300px); }
        }

        // Over the sm
        @include media-breakpoint-up(sm){
            min-height: 80px;
            max-width: 350px;
            right: calc(100% + 500px);
            top: 0;
        
            @keyframes movein {
                from { left: calc(100% + 500px); }
                to   { left: calc(100% - 350px); }
            }
            @keyframes moveout {
                from { left: calc(100% - 350px); }
                to   { left: calc(100% + 500px); }
            }
        }

        &--danger {
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06), 0px 3px 0px $color-danger;
        }
        &--success {
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06), 0px 3px 0px $color-secondary;
        }
        &--info {
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06), 0px 3px 0px $color-primary;
        }
        &--warning {
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06), 0px 3px 0px $color-warning;
        }

        &__show {
            animation: movein 1s ease forwards, moveout 1s 5s ease forwards;
        }

        &__icon-container {
            flex: 15;
            display: flex;

            @include media-breakpoint-up(sm) {
                flex: 25;
            }
    
            &--danger {
                background-color: $color-danger;
            }
            &--success {
                background-color: $color-secondary;
            }
            &--info {
                background-color: $color-primary;
            }
            &--warning {
                background-color: $color-warning;
            }
        }
        &__icon {
            margin: auto;
            height: 35px;
            width: 35px;

            @include media-breakpoint-up(sm) {
                height: 60px;
                width: 60px;
            }
        }

        &__text-container {
            flex: 85;
            padding: 5px;
            display: flex;

            @include media-breakpoint-up(sm) {
               padding: 10px;
               flex: 75;
            }
        }
        &__text {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            color: #373435;
            margin: auto 5px;

            @include media-breakpoint-up(sm) {
              margin: auto 10px;
            }
        }
    }
</style>
